<template>
	<div class="h-panel-body padding font-bold">
		<Row :space="9">
			<Cell width="6" v-for="(type,i) in displayCards" :key="i">
				<div class="carry-card">
					<p class="card-title">{{type.name}}</p>
					<p class="pnumber">{{resolveCardAmount(type)|numFormat}}</p>
					<p v-if="type.type === 'foreignRevaluation' && foreignCurrency.msg" class="foreign-tip">{{foreignCurrency.msg}}</p>
					<div class="card-action">
						<template v-if="type.type === 'foreignRevaluation'">
							<button v-if="foreignCurrency.voucherId" class="h-btn h-btn-green" @click="openVoucher(foreignCurrency.voucherId)">查看凭证</button>
							<button v-else-if="foreignCurrency.executed" class="h-btn" disabled>已完成</button>
							<button v-else-if="foreignCurrency.canExecute" class="h-btn h-btn-primary" :disabled="foreignCurrency.loading" @click="executeForeignCurrencyRevaluation">
								{{foreignCurrency.loading ? '处理中...' : '执行调汇'}}
							</button>
							<button v-else class="h-btn" disabled>{{foreignCurrency.hasForeignBalance ? '待完成' : '无需调汇'}}</button>
						</template>
						<template v-else>
							<router-link v-if="getTraditionalCard(type).voucherId" tag="button" :to="{name:'VoucherForm', params: { voucherId: getTraditionalCard(type).voucherId}}" class="h-btn h-btn-green">查看凭证</router-link>
							<router-link v-else-if="getTraditionalCard(type).canGenerate" tag="button" :to="{name:'VoucherForm', params: { checkData,type }}" class="h-btn h-btn-primary">生成凭证</router-link>
							<button v-else class="h-btn" disabled>无需生成</button>
						</template>
					</div>
				</div>
			</Cell>
		</Row>
		<div align="center" style="margin-top: 20px;">
			<button class="h-btn h-btn-text-primary h-btn-transparent" @click="back">上一步</button>
			<button class="h-btn h-btn-primary" @click="check">下一步</button>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import Decimal from 'decimal.js';
	import {
		DEFAULT_SUBJECT_ENCODING,
		convertSubjectCodeByEncoding,
		matchesSubjectEncoding,
		parseSubjectEncoding
	} from '@/utils/subjectEncoding';

	export default {
		name: "checkout",
		props: {
			checkYear: [Number, String],
			checkMonth: [Number, String],
		},
		computed: {
			...mapState(['currentAccountSets']),
			typeList() {
				let isQy = this.currentAccountSets.accountingStandards === 0;
				return [
					{
						code: isQy ? '5401' : '6401',
						type: 'jzxscb',
						name: '结转销售成本',
						subject: isQy ? [5401, 1405] : [6401, 1405]
					},
					{
						code: '2211',
						type: 'jtzgxc',
						name: '计提职工薪酬',
						subject: isQy ? [this.codeConversion(560201), this.codeConversion(560101), 2211] : [this.codeConversion(660201), this.codeConversion(660101), 2211]
					},
					{
						code: '1602',
						type: 'jtzj',
						name: '计提折旧',
						subject: isQy ? [this.codeConversion(560207), 1602] : [this.codeConversion(660207), this.codeConversion(660107), 1602]
					},
					{
						code: '1801',
						type: 'txdtfy',
						name: '摊销待摊费用',
						subject: isQy ? [this.codeConversion(560212), 1801] : [this.codeConversion(660212), 1801]
					},
					{
						code: isQy ? '5401' : '6403',
						type: 'jtsj',
						name: '计提税金',
						subject: isQy ? [5403, this.codeConversion(222108), this.codeConversion(222113), this.codeConversion(222114)] : [6403, this.codeConversion(222108), this.codeConversion(222113), this.codeConversion(222114)]
					},
					{
						code: this.codeConversion('222102'),
						type: 'jzwjzzs',
						name: '结转未交增值税',
						subject: [this.codeConversion(22210103), this.codeConversion(222102)]
					},
					{
						code: isQy ? '5401' : '6801',
						type: 'jtsds',
						name: '计提所得税',
						subject: isQy ? [5801, this.codeConversion(222106)] : [6801, this.codeConversion(222106)]
					},
					{
						code: isQy ? '3103' : '4103',
						type: 'jzsy',
						name: '结转损益',
						subject: isQy ? [3103] : [4103]
					}
				]
			},
			displayCards() {
				let cards = this.typeList.slice();
				cards.splice(cards.length - 1, 0, {
					code: 'foreignRevaluation',
					type: 'foreignRevaluation',
					name: '外币调汇'
				});
				return cards;
			}
		},
		data() {
			return {
				selected: 'carry-forward',
				checkData: {},
				carryForwardStatusMap: {},
				foreignCurrency: {
					loading: false,
					hasForeignBalance: false,
					canExecute: false,
					executed: false,
					voucherId: null,
					adjustmentAmount: 0,
					details: [],
					msg: ''
				}
			}
		},
		methods: {
			resolveCardAmount(type) {
				if (type.type === 'foreignRevaluation') {
					if (this.foreignCurrency.adjustmentAmount) {
						return this.foreignCurrency.adjustmentAmount;
					}
					if (!this.foreignCurrency.details || !this.foreignCurrency.details.length) {
						return 0;
					}
					return this.foreignCurrency.details.reduce((sum, item) => {
						let difference = item && item.revaluationDifference ? item.revaluationDifference : 0;
						return Decimal(sum).plus(Decimal(difference || 0).abs()).toNumber();
					}, 0);
				}
				return this.getTraditionalCard(type).amount || 0;
			},
			getTraditionalCard(type) {
				return this.carryForwardStatusMap[type.type] || {
					amount: 0,
					voucherId: null,
					canGenerate: false
				};
			},
			loadTraditionalStatus() {
				return this.$api.checkout.carryForwardStatus({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.carryForwardStatusMap = data || {};
				});
			},
			loadForeignCurrencyStatus() {
				this.foreignCurrency.loading = true;
				this.$api.checkout.foreignCurrencyCheck({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.foreignCurrency = Object.assign({}, this.foreignCurrency, {
						loading: false,
						hasForeignBalance: !!data.hasForeignBalance,
						canExecute: !!data.canExecute,
						executed: !!data.executed,
						voucherId: data.voucherId || null,
						adjustmentAmount: data.adjustmentAmount || 0,
						details: data.details || [],
						msg: data.result ? '' : (data.msg || '')
					});
				}).catch(() => {
					this.foreignCurrency = Object.assign({}, this.foreignCurrency, {
						loading: false,
						msg: '外币调汇状态加载失败'
					});
				});
			},
			executeForeignCurrencyRevaluation() {
				this.foreignCurrency.loading = true;
				this.$api.checkout.foreignCurrencyRevaluation({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.$Message.success(data.message || '期末调汇已完成');
					this.loadForeignCurrencyStatus();
				}).catch(() => {
					this.foreignCurrency.loading = false;
				});
			},
			openVoucher(voucherId) {
				this.$router.push({name: 'VoucherForm', params: {voucherId}});
			},
			check() {
				this.$router.push({name: 'Check', params: this.checkData})
			},
			back() {
				this.$router.back()
			},
			init() {
				this.loadTraditionalStatus();
				this.loadForeignCurrencyStatus();
			},
			codeConversion(code) {
				code = String(code);
				let encoding = parseSubjectEncoding(this.currentAccountSets && this.currentAccountSets.encoding);
				if (!matchesSubjectEncoding(code, encoding)) {
					code = convertSubjectCodeByEncoding(code, DEFAULT_SUBJECT_ENCODING, encoding);
				}
				return code;
			}
		},
		mounted() {
			this.checkData = {checkYear: this.checkYear, checkMonth: this.checkMonth};
			this.init();
		}
	}
</script>

<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		color: #000;
		border-radius: 3px;
		background-color: #Fff;
		min-height: 190px;
		border: 1px solid #eee;
	}

	.carry-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		height: 100%;
	}

	.card-title {
		margin: 18px 0 20px;
		line-height: 28px;
	}

	.pnumber {
		margin: 0 0 12px;
		font-size: larger;
		line-height: 40px;
	}

	.foreign-tip {
		margin: 0;
		padding: 0 20px;
		font-size: 12px;
		line-height: 18px;
		color: #999;
		min-height: 36px;
	}

	.card-action {
		margin-top: auto;
		padding-bottom: 16px;
	}

	.card-action .h-btn {
		min-width: 132px;
	}

</style>
